import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Paho } from 'ng2-mqtt/mqttws31';
import { ConfigService } from '../config.service';
import * as myGlobals from '../globals';

@Injectable({
  providedIn: 'root'
})
export class MqttService {
  private _client: Paho.MQTT.Client;
  public missionAnnounced$ = new Subject<any>();
  private mqttOptions = {
    userName: myGlobals.MQTT_USERNAME,
    password: myGlobals.MQTT_PASSWORD,
    useSSL: myGlobals.MQTT_USESSL,
    timeout: 60,
    keepAliveInterval: 60,
    onSuccess: mqtt => this.onSuccess(mqtt),
    onFailure: e => this.onMqttConnectionLost(e)
  };

  constructor(private _cookie: ConfigService) {
    // !this._client.isConnected() ? this._client.connect(this.mqttOptions) : '';
  }
  mqttConnection() {
    console.log('mqtt connection');
    this.mqttOptions = {
      userName: myGlobals.MQTT_USERNAME,
      password: myGlobals.MQTT_PASSWORD,
      useSSL: myGlobals.MQTT_USESSL,
      timeout: 60,
      keepAliveInterval: 60,
      onSuccess: mqtt => this.onSuccess(mqtt),
      onFailure: e => this.onMqttConnectionLost(e)
    };
    this._client = new Paho.MQTT.Client(
      myGlobals.MQTT_HOST,
      'myClientId' + new Date().getTime()
    );
    this._client.onMessageArrived = message => {
      this.onMqttMessageArrived(message.payloadString);
    };

    this._client.onConnectionLost = response => {
      this.onMqttConnectionLost(response);
    };
    this._client.connect(this.mqttOptions)

  }
  onSuccess(mqtt) {
    setTimeout(() => {
      this._client.subscribe(sessionStorage.getItem('mqtt'), { qos: 2 });
      this._client.subscribe('godsview/' + '#', { qos: 2 });
      console.log('Subscribed', sessionStorage.getItem('mqtt'));
    }, 3000)
  }

  private onMqttConnectionLost(response) {
    console.log('onConnectionLost', response);
    if (response.errorCode !== 0) {
      const temp = {
        userName: myGlobals.MQTT_USERNAME,
        password: myGlobals.MQTT_PASSWORD,
        useSSL: myGlobals.MQTT_USESSL,
        timeout: 60,
        keepAliveInterval: 60,
        onSuccess: mqtt => this.onSuccess(mqtt),
        onFailure: e => this.onMqttConnectionLost(e)
      };
      this._client.connect(temp);
    }
  }

  private onMqttMessageArrived(message: string) {
    // console.log('MQTT SERVICE', JSON.parse(message));
    this.missionAnnounced$.next(message);
  }

  announceMqtt(data: string) {
    this.missionAnnounced$.next(data);
  }
  mqttDisconnect() {
    this._client.unsubscribe(sessionStorage.getItem('mqtt'), {});
    this._client.isConnected() ? this._client.disconnect() : '';
  }
}
